import React from "react";
import { getElakayLang } from "../auth";
import './RadioFilters.css';

const RadioBox = ({ prices = [], handleFilters, infoSource }) => {
    const handleChange = event => {
        handleFilters(event.target.value);
    };

        const {obj} = getElakayLang();
                 const {code }= obj

    return (
        <div className="radio-group-modern price-radio-group">
            {prices?.map((p, i) => (
                <div 
                    key={i} 
                    // className="radio-item-modern price-radio-item"
                    style={{ animationDelay: `${i * 0.05}s` }}
                >
                    <input
                        onChange={handleChange}
                        value={`${p._id}`}
                        name="price-filter"
                        type="radio"
                        className="radio-input-modern check2"
                        id={`price-${p._id}`}
                    />
                    <label 
                        className="radio-label-modern" 
                        htmlFor={`price-${p._id}`}
                    >
                        <span className="radio-circle"></span>
                        <span className="radio-text">{p.name[code]}</span>
                    </label>
                </div>
            ))}
        </div>
    );
};

export default RadioBox;
